import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AranSnackBarService } from '@aran-client/aran-web-ui-toolkit';

@Injectable()
export class NotificationInterceptor implements HttpInterceptor {
  constructor(private notificationService: AranSnackBarService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && event.status === 200) {
          const body = event.body as { message?: string };
          if (body?.message) {
            this.notificationService.showSuccess(body.message, 10000);
          }
        }
      })
    );
  }
}
